import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-100 border-t border-secondary-200/60">
      <div className="w-full px-4 md:px-6">
        <div className="py-12 md:py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-play-circle-fill text-lg text-white"></i>
              </div>
              <span className="font-heading font-bold text-foreground-950">国产视频大全</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              国产视频精选平台，汇聚海量正版高清国产视频资源。涵盖影视剧、综艺、纪录片、短视频等多元内容，每日更新，免费畅享。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-900 mb-4">热门分类</h4>
            <div className="flex flex-col gap-2">
              {categories.slice(0, 5).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-900 mb-4">快速链接</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">首页</Link>
              <Link to="/category/yingshiju" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">分类浏览</Link>
              <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-900 mb-4">联系我们</h4>
            <div className="flex flex-col gap-2">
              <p className="text-sm text-foreground-600">
                <i className="ri-mail-line mr-2"></i>contact@guochanshipin.com
              </p>
              <p className="text-sm text-foreground-600">
                <i className="ri-phone-line mr-2"></i>400-888-6666
              </p>
              <p className="text-sm text-foreground-600">
                <i className="ri-map-pin-line mr-2"></i>北京市朝阳区望京科技园A座
              </p>
            </div>
          </div>
        </div>

        <div className="py-6 border-t border-secondary-300/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-foreground-500">
            &copy; 2026 国产视频大全 版权所有 | 京ICP备2026000001号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 hover:text-primary-500 transition-colors text-sm" rel="nofollow">隐私政策</a>
            <a href="#" className="text-foreground-500 hover:text-primary-500 transition-colors text-sm" rel="nofollow">使用条款</a>
            <a href="#" className="text-foreground-500 hover:text-primary-500 transition-colors text-sm" rel="nofollow">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}